import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PureComponent, Children } from 'react';
import { getCommunitiesContext } from '../../selectors/communities-context-selectors';
import { createNavigationStrategy } from '../../services/create-navigation';
import { isOneApp } from '@wix/communities-blog-client-common/dist/src/selectors/search-params-selectors';

class NavigationProvider extends PureComponent {
  navigationSubscribers = [];

  getChildContext() {
    return {
      navigation: this.props.navigation,
      subscribeToNavigationChange: this.subscribeToNavigationChange,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.navigation !== this.props.navigation) {
      this.provideNewNavigationToSubscribers(nextProps.navigation);
    }
  }

  subscribeToNavigationChange = cb => {
    this.navigationSubscribers.push(cb);
    return () => this.navigationSubscribers.splice(this.navigationSubscribers.findIndex(cb), 1);
  };

  provideNewNavigationToSubscribers = newNavigation => {
    this.navigationSubscribers.forEach(cb => cb(newNavigation));
  };

  render() {
    return Children.only(this.props.children);
  }
}

NavigationProvider.propTypes = {
  children: PropTypes.element.isRequired,
  navigation: PropTypes.object.isRequired,
};

NavigationProvider.childContextTypes = {
  navigation: PropTypes.object.isRequired,
  subscribeToNavigationChange: PropTypes.func.isRequired,
};

function mapStateToProps(state, { navigation }) {
  return {
    navigation:
      navigation ||
      createNavigationStrategy({
        communitiesContext: getCommunitiesContext(state),
        isOneApp: isOneApp(state),
      }),
  };
}

export default connect(mapStateToProps)(NavigationProvider);
